import { ListBase, useGetIdentity, useListContext } from "ra-core";
import { CreateButton } from "@/components/admin/create-button";
import { ExportButton } from "@/components/admin/export-button";
import { ListPagination } from "@/components/admin/list-pagination";
import { SortButton } from "@/components/admin/sort-button";

import { TopToolbar } from "../layout/TopToolbar";
import { CompanyEmpty } from "./CompanyEmpty";
import { CompanyListFilter } from "./CompanyListFilter";
import { ImageList } from "./GridList";
import { CompanySearchBar } from "../misc/ResponsiveFilters";

export const CompanyList = () => {
  const { identity } = useGetIdentity();
  if (!identity) return null;
  return (
    <ListBase
      perPage={25}
      sort={{ field: "name", order: "ASC" }}
      filter={{ 'is_deleted@eq': false }}
    >
      <CompanyListLayout />
    </ListBase>
  );
};

const CompanyListLayout = () => {
  const { data, isPending, filterValues } = useListContext();
  const hasFilters = filterValues && Object.keys(filterValues).length > 0;

  if (isPending) return null;
  if (!data?.length && !hasFilters) return <CompanyEmpty />;

  return (
    <div className="flex flex-row gap-0 h-full mt-0 items-stretch overflow-hidden w-full">
      <CompanyListFilter />
      <div className="erp-list-container flex-1 min-w-0 px-6 flex flex-col h-full pb-4">
        {/* Top Header Action Bar */}
        <div className="flex items-center justify-between pb-4 pt-6 shrink-0 mt-2">
          <div className="flex items-center gap-4">
            <h2 className="text-2xl font-bold text-foreground dark:text-slate-100 ml-2">Companies</h2>
          </div>
          <TopToolbar>
            <CompanySearchBar />
            <SortButton 
              fields={["name", "created_at", "nb_contacts"]} 
              className="bg-primary/10 hover:bg-primary/20 text-primary hover:text-primary/90 border border-primary/20 hover:border-primary/30 transition-colors h-9 rounded-lg font-semibold cursor-pointer dark:bg-teal-950/30 dark:text-teal-300 dark:border-teal-900/50 dark:hover:bg-teal-900/40"
            />
            <ExportButton 
              className="bg-primary/10 hover:bg-primary/20 text-primary hover:text-primary/90 border border-primary/20 hover:border-primary/30 transition-colors h-9 rounded-lg font-semibold cursor-pointer dark:bg-teal-950/30 dark:text-teal-300 dark:border-teal-900/50 dark:hover:bg-teal-900/40"
            />
            <CreateButton />
          </TopToolbar>
        </div>

        {/* Professional Card Container */}
        <div className="flex-1 flex flex-col min-h-0 border border-border rounded-xl bg-card shadow-sm overflow-hidden mb-2">
          {/* Scrollable grid contents */}
          <div className="flex-1 overflow-y-auto scrollbar-hide">
            <ImageList />
          </div>

          {/* Clean, rectangular docked footer pagination */}
          <div className="bg-muted/20 border-t border-border py-2.5 px-4 shrink-0">
            <ListPagination rowsPerPageOptions={[10, 25, 50, 100]} />
          </div>
        </div>
      </div>
    </div>
  );
};
